import { kFranchiseeParamId } from '@utils/constants'

export function withFranchiseeId(
  url: string,
  franchiseeId?: string
): string {
  if (!franchiseeId || !url || url.startsWith('http')) return url

  const [pathAndQuery, hash = ''] = url.split('#')
  const [path, query = ''] = pathAndQuery.split('?')
  const params = new URLSearchParams(query)
  params.set(kFranchiseeParamId, franchiseeId)
  const queryString = params.toString()

  return `${path}?${queryString}${hash ? `#${hash}` : ''}`
}
